import { Pinia, Store } from 'pinia-class-component';
import { Activity, ActivityControllerUIClient, VMActivitiesIndex } from '../components/backend/backendapi';
import { initClient } from '../api';

@Store({
  id: 'ActivityStore',
  name: 'ActivityStore',
})
export default class ActivityStore extends Pinia {
  private readonly activityApi = initClient(ActivityControllerUIClient);

  //data
  private _loadingPromise: Promise<VMActivitiesIndex> | null = null;
  private _activities: Activity[] = [];

  //getter
  get loading(): boolean {
    return this._loadingPromise !== null;
  }

  get activities(): Activity[] {
    return this._activities;
  }

  //actions
  clear(): void {
    this._activities.splice(0);
  }

  setActivities(activities: Activity[]): void {
    this._activities.splice(0);
    this._activities.push(...activities);
  }

  rememberActivity(activity: Activity): void {
    const index = this._activities.findIndex(e => e.id == activity.id);
    if (index >= 0) {
      this._activities.splice(index, 1, activity);
    } else {
      this._activities.push(activity);
    }
  }

  forgetActivity(activity: Activity): void {
    const index = this._activities.findIndex(e => e.id == activity.id);
    if (index >= 0) {
      this._activities.splice(index, 1);
    }
  }

  async reload(force: boolean = false): Promise<void> {
    if (this._loadingPromise) {
      await this._loadingPromise;
      if (!force) {// when force is true, wait for the current operation to complete, then reload
        return;
      }
    }

    try {
      this._loadingPromise = this.activityApi.getActivites(undefined, undefined, 0, 0x7fffffff);
      const activities = await this._loadingPromise;
      this.setActivities(activities.activities?.data ?? []);
    } catch (err) {
      this.clear();
    } finally {
      this._loadingPromise = null;
    }
  }

  async loadIfAbsent(): Promise<void> {
    if (this._activities.length > 0) {
      return;
    }
    return await this.reload();
  }
}